const handleFbPopupLoginAction = (response, uri) => {
    const query = $.param({ access_token: response.authResponse.accessToken });
    window.location.assign(`${uri}?${query}`);
};

export default handleFbPopupLoginAction;
